import { Col, Row } from 'antd'
import { CheckOutlined, LoadingOutlined } from '@ant-design/icons'
import styles from './index.module.less'

export const IdentityItem = (props: any) => {
  const { data, isActive, onClick, loading } = props
  return (
    <Row
      className={styles.identityItem}
      style={loading ? {
        opacity: 0.6,
        cursor: 'not-allowed'
      } : void 0}
      justify="space-between"
      align="middle"
      onClick={onClick}
    >
      <Col>
        <div style={{ fontSize: 12, marginBottom: 3, lineHeight: 1 }}>{data.roleName}</div>
        <span style={{ fontSize: 12, color: '#aaa' }}>{data.orgNamePath}</span>
      </Col>
      <Col>
        {!loading && isActive ? (
          <span style={{ color: '#00A865' }}>
            <CheckOutlined />
          </span>
        ) : null}

        {loading ? (
          <span style={{ color: '#333' }}>
            <LoadingOutlined />
          </span>
        ) : null}
      </Col>
    </Row>
  )
}
